{% block coman_consent_manager_config_page %}
    <sw-page
            class="coman-consent-manager-config-page sw-settings-index"
            :show-smart-bar="true"
    >

        {% block coman_consent_manager_header %}
            <template #smart-bar-header>
                <h2>
                    {{ $tc('sw-settings.index.title') }}
                    <mt-icon
                            name="regular-chevron-right-xs"
                            size="16px"
                    />
                    {{ $tc('coman.title') }}
                </h2>
            </template>
        {% endblock %}


        {% block coman_consent_manager_config_page_actions %}
            <template #smart-bar-actions>

                {% block coman_consent_manager_config_page_actions_save %}
                    <sw-button-process
                                v-model:value="isSaveSuccessful"
                            class="sw-settings-login-registration__save-action"
                            variant="primary"
                            :isLoading="isLoading"
                            :disabled="isLoading"
                            @click="onSave"
                            @process-finish="onSaveFinish"
                    >
                        {{ $tc('global.default.save') }}
                    </sw-button-process>
                {% endblock %}

            </template>
        {% endblock %}


        {% block coman_consent_manager_config_page_content %}
            <template #content>
                <sw-card style="margin-top: 20px;">

                    {% block coman_consent_manager_config_page_content_sales_channel_title %}
                        <template #title>
                            <div class="sw-card__title">
                                {{ $tc('coman.salesChannel.label') }}
                            </div>
                        </template>
                    {% endblock %}

                    {% block sw_sales_channel_switch_select %}
                        <sw-sales-channel-switch
                                :label="$tc('sw-settings.system-config.labelSalesChannelSelect')"
                                @change-sales-channel-id="onSalesChannelChanged"
                        />
                    {% endblock %}

                </sw-card>


                <sw-card style="margin-top: 20px;">

                    {% block coman_consent_manager_config_page_content_install_title %}
                        <template #title>
                            <div class="sw-card__title">
                                {{ $tc('coman.install.label') }}
                            </div>
                        </template>
                    {% endblock %}

                    {% block coman_consent_manager_config_page_content_install_instruction %}
                        <div style="margin-bottom: 30px;" v-html="$tc('coman.install.instruction')"></div>
                    {% endblock %}

                    {% block coman_consent_manager_config_page_content_install_button %}
                        <sw-button variant="primary" @click="openConsentPopup">
                            {{ $tc('coman.install.label') }}
                        </sw-button>
                    {% endblock %}

                </sw-card>



                <sw-card style="margin-top: 20px;">

                    {% block coman_consent_manager_config_page_content_general_title %}
                        <template #title>
                            <div class="sw-card__title">
                                {{ $tc('coman.general.label')}}
                            </div>
                        </template>
                    {% endblock %}

                    {% block coman_consent_manager_warning %}
                        <sw-alert
                                variant="warning"
                                v-if="isInherited && salesChannelId && !isSaveSuccessful"
                                class="sw-alert">
                            {{ $tc('coman.warning.inheritance') }}
                        </sw-alert>
                    {% endblock %}

                    {% block coman_consent_manager_success %}
                        <sw-alert variant="success" v-if="popupSuccess" class="sw-alert" style="margin-top: 10px;">
                            {{ $tc('coman.success.popupDataInserted') }}
                        </sw-alert>
                    {% endblock %}

                    <!-- eslint-disable-next-line sw-deprecation-rules/no-twigjs-blocks -->
                    {% block coman_consent_manager_config_page_content_active %}
                    <sw-container>
                        <sw-inherit-wrapper
                                bordered
                                    v-model:value="active"
                                :has-parent="!!salesChannelId"
                                :inherited-value="getInheritValue('formId')"
                        >
                            <template #content="props">

                                <sw-switch-field-deprecated
                                        :key="componentKey"
                                        bordered
                                        :map-inheritance="props"
                                        :label="$tc('coman.active.label')"
                                        :disabled="props.isInherited"
                                        :value="props.currentValue"
                                            @update:value="props.updateCurrentValue"
                                />

                            </template>
                        </sw-inherit-wrapper>
                    </sw-container>
                    {% endblock %}


                    {% block coman_consent_manager_config_page_content_form_id %}
                        <sw-inherit-wrapper
                                    v-model:value="formId"
                                :has-parent="!!salesChannelId"
                                :inherited-value="getInheritValue('formId')"
                        >
                            <template #content="props">
                                {{ updateCurrentValue('formId', props.isInherited) }}
                                <sw-text-field-deprecated
                                        :key="componentKey"
                                        :map-inheritance="props"
                                        :value="props.currentValue"
                                        :disabled="props.isInherited"
                                        :label="$tc('coman.formId.label')"
                                        required
                                        :class="{ 'has--error': errors.formId && !props.isInherited && !props.currentValue }"
                                        @update:value="props.updateCurrentValue"
                                ></sw-text-field-deprecated>
                                <div v-if="errors.formId && !props.isInherited && !props.currentValue" class="sw-field__error">{{ errors.formId }}</div>
                            </template>
                        </sw-inherit-wrapper>
                    {% endblock %}

                    {% block coman_consent_manager_config_page_content_cdn %}
                        <sw-inherit-wrapper
                                    v-model:value="cdn"
                                :has-parent="!!salesChannelId"
                                :inherited-value="getInheritValue('cdn')"
                        >
                            <template #content="props">
                                {{ updateCurrentValue('cdn', props.isInherited) }}
                                <sw-text-field-deprecated
                                        :key="componentKey"
                                        :map-inheritance="props"
                                        :value="props.currentValue"
                                        :disabled="props.isInherited"
                                        :label="$tc('coman.cdn.label')"
                                        required
                                        :class="{'has--error': errors.cdn && !props.isInherited && !props.currentValue}"
                                        @update:value="props.updateCurrentValue"
                                ></sw-text-field-deprecated>
                                <div v-if="errors.cdn && !props.isInherited && !props.currentValue" class="sw-field__error">{{ errors.cdn }}</div>
                            </template>
                        </sw-inherit-wrapper>

                    {% endblock %}

                    {% block coman_consent_manager_config_page_content_host %}
                        <sw-inherit-wrapper
                                    v-model:value="host"
                                :has-parent="!!salesChannelId"
                                :inherited-value="getInheritValue('host')"
                        >
                            <template #content="props">
                                {{ updateCurrentValue('host', props.isInherited) }}
                                <sw-text-field-deprecated
                                        :key="componentKey"
                                        :map-inheritance="props"
                                        :value="props.currentValue"
                                        :disabled="props.isInherited"
                                        :label="$tc('coman.host.label')"
                                        required
                                        :class="{'has--error': errors.host && !props.isInherited && !props.currentValue}"
                                        @update:value="props.updateCurrentValue"
                                ></sw-text-field-deprecated>
                                <div v-if="errors.host && !props.isInherited && !props.currentValue" class="sw-field__error">{{ errors.host }}</div>
                            </template>
                        </sw-inherit-wrapper>
                    {% endblock %}

                    {% block coman_consent_manager_config_page_content_blocking_mode %}
                        <sw-select-field-deprecated
                                :value="blockingMode"
                                    v-model="blockingMode"
                                :label="$tc('coman.blockingMode.label')"
                                :options="options"
                                    @update:value="onChangeType"

                        />
                    {% endblock %}


                    {% block coman_consent_manager_config_page_content_additional_html %}
                        <sw-inherit-wrapper
                                    v-model:value="additionalHtml"
                                :has-parent="!!salesChannelId"
                                :inherited-value="getInheritValue('additionalHtml')"
                        >
                            <template #content="props">

                                <sw-textarea-field-deprecated
                                        :key="componentKey"
                                        :label="$tc('coman.additionalHtml.label')"
                                        :map-inheritance="props"
                                        :value="props.currentValue"
                                        :disabled="props.isInherited"
                                        @update:value="props.updateCurrentValue"
                                ></sw-textarea-field-deprecated>
                            </template>
                        </sw-inherit-wrapper>
                    {% endblock %}


                    {% block coman_consent_manager_config_page_content_bottom_instruction %}
                        <div style="margin-bottom: 30px;" v-html="$tc('coman.install.bottomInstruction')"></div>
                    {% endblock %}
                </sw-card>
            </template>
        {% endblock %}
    </sw-page>
{% endblock %}
